document.addEventListener('DOMContentLoaded', () => {
  const spoiler = document.querySelectorAll('.spoiler');

  for (let index = 0; index < spoiler.length; index++) {
    const item = spoiler[index];
    const top = item.querySelector('.spoiler__top');

    top.addEventListener('click', () => {
      item.classList.toggle('is-open');
    });
  }
});
